import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import { getDevice } from '@panel/commons/helpers';
import { sendCustomTrackingInfo } from '@panel/commons';
import { BannerContainer, ContentWrapper, LeftSection, IconWrapper, Description, CTAButton } from './styles';
import { InfoIcon } from './Icons';
import { getRedirectUrl } from './getRedirectUrl';

const BannerInfo = ({ className = '', dataPubli = 'banner-info', isEdition = false, postingId = '' }) => {
  const { t } = useTranslation();
  const device = getDevice();

  useEffect(() => {
    sendCustomTrackingInfo({
      event: 'impression_modal',
      content_group: 'Publicador',
      modal_name: 'Volver al publicador de BUMEX'
    });
  }, []);

  const handleCTAClick = () => {
    sendCustomTrackingInfo({
      event: 'click_modal',
      content_group: 'Publicador',
      modal_name: 'Volver al publicador de BUMEX'
    });

    Cookies.set('showOldReppro', 'true', { expires: 2 / 24 });

    const url = getRedirectUrl(isEdition, postingId);
    window.location.href = url;
  };

  return (
    <BannerContainer device={device} className={className} data-publi={dataPubli}>
      <ContentWrapper device={device}>
        <LeftSection device={device}>
          <IconWrapper>
            <InfoIcon />
          </IconWrapper>
          <Description device={device}>{t('professionalPubli.bannerInfo.description')}</Description>
        </LeftSection>

        <CTAButton device={device} onClick={handleCTAClick} data-publi={`${dataPubli}-cta-button`}>
          {t('professionalPubli.bannerInfo.ctaText')}
        </CTAButton>
      </ContentWrapper>
    </BannerContainer>
  );
};

BannerInfo.propTypes = {
  className: PropTypes.string,
  dataPubli: PropTypes.string,
  isEdition: PropTypes.string,
  postingId: PropTypes.string
};

export default BannerInfo;
